var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'imageContainer': true,
    'fitBlock': _vm.fitBlock,
    'imageContainer_relative': _vm.relative,
    'imageContainer_absolute': _vm.absolute,
    'imageContainer_fillHeight': _vm.isImageFillContainer,
}, _obj['imageContainer_' + _vm.modifier] = _vm.modifier, _obj[_vm.className] = _vm.className, _obj )},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],class:( _obj$1 = {
      'imageContainer__image': true,
      'fitBlock': _vm.isImageFillContainer,
      'imageContainer__image_circle': _vm.circle,
    }, _obj$1[_vm.imageClasses] = _vm.imageClasses, _obj$1 ),attrs:{"alt":_vm.alt}}),_vm._v(" "),_vm._t("default")],2)
var _obj;
var _obj$1;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a4f916","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LazyImage.vue
// module id = null
// module chunks = 